<template>
  <div class="admin-page premium-detail-page">
    <v-btn
      text
      small
      color="primary"
      :to="backRoute"
      class="premium-detail-page__back"
    >
      <v-icon
        left
        small
      >
        {{ backIcon }}
      </v-icon>
      Premium listesine dön
    </v-btn>
    <admin-page-header
      eyebrow="Premium / Üyelik detayı"
      :title="`Premium #${premiumId}`"
      :description="ownerDescription"
    ></admin-page-header>
    <v-progress-linear
      v-if="loading"
      indeterminate
      aria-label="Üyelik yükleniyor"
    ></v-progress-linear>
    <v-alert
      v-if="errorMessage"
      type="error"
      outlined
    >
      {{ errorMessage }}
      <v-btn
        text
        small
        @click="loadPremium"
      >
        Tekrar dene
      </v-btn>
    </v-alert>
    <template v-if="premium">
      <div class="premium-detail-page__identity">
        <v-chip
          small
          outlined
          color="primary"
        >
          {{ premium.packageTime || 'Paket belirtilmemiş' }}
        </v-chip>
        <span>{{ premium.customPremium ? 'Manuel üyelik' : platformLabel }}</span>
        <span>Tüm saatler Türkiye saatidir (UTC+3).</span>
      </div>
      <premium-lifecycle-timeline
        :premium-user-id="premiumId"
        active
      ></premium-lifecycle-timeline>
      <details class="premium-detail-page__record">
        <summary>Üyelik, mağaza ve sözleşme bilgileri</summary>
        <premium-record-details :selected-premium="premium"></premium-record-details>
      </details>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mdiArrowLeft } from '@mdi/js'
import AdminPageHeader from '@/components/admin/AdminPageHeader.vue'
import PremiumLifecycleTimeline from './PremiumLifecycleTimeline.vue'
import PremiumRecordDetails from './PremiumRecordDetails.vue'

export default {
  name: 'PremiumDetailPage',
  components: { AdminPageHeader, PremiumLifecycleTimeline, PremiumRecordDetails },
  data: () => ({
    premium: null, loading: false, errorMessage: '', requestSequence: 0, backIcon: mdiArrowLeft,
  }),
  computed: {
    premiumId() { return this.$route.params.premiumId },
    backRoute() { return { name: 'premium', query: this.$route.query } },
    ownerDescription() {
      if (!this.premium) return 'Üyeliğin güncel durumu ve açıklamalı geçmişi'
      const ownerKnown = this.premium.ownerResolved === true
        || (this.premium.ownerResolved === undefined && this.premium.attachedToUser === true)

      return ownerKnown
        ? [this.premium.fullName, `Kullanıcı #${this.premium.id}`, this.premium.email].filter(Boolean).join(' · ')
        : 'Bu üyelik kaydının sahibi henüz doğrulanmamış.'
    },
    platformLabel() {
      return { IOS: 'App Store', ANDROID: 'Google Play' }[this.premium.premiumPlatform] || 'Mağaza üyeliği'
    },
  },
  watch: {
    premiumId: { immediate: true, handler: 'loadPremium' },
  },
  beforeDestroy() { this.requestSequence += 1 },
  methods: {
    async loadPremium() {
      this.requestSequence += 1
      const sequence = this.requestSequence
      this.loading = true
      this.errorMessage = ''
      this.premium = null
      try {
        // The overview search includes Premium IDs. Check the exact ID because it is a substring search.
        const response = await axios.get(`${process.env.VUE_APP_BASE_API_URL}admin/premium/overview`, {
          params: { search: this.premiumId },
        })
        if (sequence !== this.requestSequence) return
        this.premium = (response?.data?.data?.users || [])
          .find(item => String(item.premiumUserId) === String(this.premiumId)) || null
        if (!this.premium) this.errorMessage = 'Bu Premium kaydı bulunamadı.'
      } catch (error) {
        if (sequence === this.requestSequence) {
          this.errorMessage = error?.response?.data?.message || 'Üyelik bilgileri yüklenemedi.'
        }
      } finally {
        if (sequence === this.requestSequence) this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.premium-detail-page {
  --premium-surface: #fff;
  --premium-subtle: #f8fafc;
  --premium-border: #e2e8f0;
  --premium-text: #334155;
  --premium-strong: #1e293b;
  --premium-muted: #64748b;
  --premium-link: #b91c1c;
  --premium-warning-text: #854d0e;
  max-width: 1480px;
  margin: 0 auto;
  gap: 16px;
}
.theme--dark .premium-detail-page {
  --premium-surface: rgba(12, 20, 35, 0.92);
  --premium-subtle: #111c30;
  --premium-border: rgba(148, 163, 184, 0.22);
  --premium-text: #e2e8f0;
  --premium-strong: #f8fafc;
  --premium-muted: #a8b5c8;
  --premium-link: #fda4af;
  --premium-warning-text: #fcd34d;
}
.premium-detail-page__back { align-self: flex-start; color: var(--premium-link) !important; }
.premium-detail-page__identity { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; color: var(--premium-muted); font-size: 0.85rem; }
.premium-detail-page__record { margin-top: 24px; border: 1px solid var(--premium-border); border-radius: 12px; background: var(--premium-surface); padding: 20px; }
.premium-detail-page__record > summary { cursor: pointer; color: var(--premium-text); font-weight: 600; }
.premium-detail-page__record[open] > summary { margin-bottom: 24px; }
</style>
